import profile from '../../fields/other/profile';

export const MUTATION_CHANGE_USER = /* GraphQL */ `
	mutation($deleteOldUser: Boolean = false, $newUserId: String!, $oldUserId: String!) {
		changeUser(deleteOldUser: $deleteOldUser, newUserId: $newUserId, oldUserId: $oldUserId) {
			${profile}
		}
	}
`;
